export var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENT"] = "PERCENT";
    DiscountType["AMOUNT"] = "AMOUNT";
})(DiscountType || (DiscountType = {}));
